import { Helmet } from 'react-helmet'

function LietosanasNoteikumi() {
  // Check localStorage for the 'lang' key
  const lang = localStorage.getItem('lang');

  // --- English Version ---
  // If lang is 'en', display the English translation
  if (lang === 'en') {
    return (
      <div className="noteikumi">
        <Helmet>
          <title>Nora Spora - Terms of Use</title>
          <meta name="description" content="Explore our terms of use.." />
          <meta name="keywords" content="privacy policy, terms of use, data protection, personal data, NORA SPORA" />
          <meta name="robots" content="index, follow" />
        </Helmet>
          <h2 className="light">Terms of Use</h2>
          <ol>
              <li>General Terms
                  <ol>
                      <li>
                      These Terms come into effect once the Buyer has confirmed them. The Buyer has created a
                      shopping cart and, at the final step of the checkout process, checked the box “I have read and
                      agree to the website terms” and clicked the “Order” button.
                      </li>
                      <li>
                      The Buyer agrees to order and accept the Products and pay for them at the Order price as
                      specified in the Agreement. Product delivery is provided only within the territory indicated on
                      the online store www.noraspora.lv.
                      </li>
                      <li>
                      The Buyer is not entitled to purchase Products from the online store www.noraspora.lv if they
                      have not read or do not agree with the Terms of Purchase.
                      </li>
                      <li>
                      Product prices in the online store www.noraspora.lv are indicated in euros, in accordance with
                      applicable laws. Prices do not include delivery costs. Delivery costs are specified separately for
                      each Order.
                      </li>
                  </ol>
              </li>
              <li>
                  Data Protection
                  <ol>
                      <li>
                      noraspora.lv takes care of the privacy and personal data protection of its Buyers, respecting
                      Buyers’ rights regarding the lawful processing of personal data under the European Parliament
                      and Council Regulation 2016/679 (GDPR) and other applicable laws and regulations in the
                      Republic of Latvia.
                      </li>
                      <li>
                      The Seller undertakes to process the personal data specified in this Agreement, retain it only for
                      the intended purpose and in the necessary scope, including for service improvement and sending
                      promotional materials. The Seller may transfer Buyer’s personal data to partners and data
                      processing companies working on the Seller’s behalf. Collected information may be used for
                      strategic and marketing purposes.
                      </li>
                  </ol>
              </li>
              <li>
                  Conclusion of Purchase–Sale Agreement
                  <ol>
                      <li>
                      The agreement between noraspora.lv and the Buyer is concluded once the Buyer has reviewed
                      the product description on the Website, selected the Products, completed the shopping cart
                      (confirming the Products meet the Buyer’s requirements), agreed to the Terms and Privacy
                      Policy, paid for the Order, and received the Order.
                      </li>
                      <li>
                      The online store is not obliged to separately notify the Buyer of its acceptance of the agreement.
                      It is considered that the store confirms the order once payment has been made.
                      </li>
                      <li>
                      Each agreement (order) concluded between the Buyer and Seller is recorded and stored in the
                      online store database.
                      </li>
                  </ol>
              </li>
              <li>
                  Buyer Rights and Obligations
                  <ol>
                      <li>
                      Buyers who are individuals have the right to withdraw. This right can be exercised within
                      14 days from receiving the Product. An email with information about the return and order
                      number must be sent to info@noraspora.lv.
                      </li>
                      <li>
                      By accessing or using the Website, you must comply with these Terms, special warnings,
                      or instructions regarding access or use, and always act in good faith and in accordance
                      with the law.
                      </li>
                      <li>
                      The Buyer can only exercise the return right if the Product is not damaged and its
                      appearance has not significantly changed. The Buyer is responsible for ensuring the
                      Product’s value, quality, and safety are maintained. Otherwise, the Seller has the right to
                      refuse the return.
                      </li>
                  </ol>
              </li>
              <li>
                  Buyer Responsibilities
                  <ol>
                      <li>
                      The Buyer agrees to provide only accurate and complete information in the registration
                      form and to update it immediately if any changes occur.
                      </li>
                      <li>
                      The Buyer agrees to use the online store fairly and properly, without disrupting its
                      operation. If the Buyer fails to comply, the Seller may limit or suspend access without
                      prior notice and is not responsible for any resulting losses.
                      </li>
                      <li>
                      The Buyer must pay for the ordered Products and receive them according to these Terms.
                      </li>
                      <li>
                      The Buyer must check the Products within 48 hours of receipt to ensure they match the
                      order.
                      </li>
                      <li>
                      The Buyer must not share login details with third parties and must notify the Seller
                      immediately if login information is lost. The Seller is not responsible for third-party
                      actions using the Buyer’s login credentials.
                      </li>
                      <li>
                      If the Buyer refuses to accept Products during delivery without a valid reason, they must
                      cover delivery and return costs.
                      </li>
                  </ol>
              </li>

              <li>
            Seller Rights
            <ol>
              <li>
                The Seller may involve personnel or subcontractors in providing the service.
              </li>
              <li>
                The Seller may limit or suspend the Buyer’s access without prior notice and is not
                responsible for any resulting losses.
              </li>
              <li>
                The Seller may cancel an order without prior notice if the Buyer does not pay within
                three business days using the methods indicated on the website.
              </li>
              <li>
                If there is doubt about the order information, the Seller will contact the Buyer using the
                provided contact details. Delivery occurs after clarification.
              </li>
              <li>
                In unforeseen circumstances, the Seller may temporarily or permanently suspend online
                store operations without prior notice. In this case, the Seller will fulfill orders or return
                paid funds.
              </li>
            </ol>
          </li>
          <li>
            Seller Responsibilities
            <ol>
              <li>
                The Seller undertakes to provide services in accordance with applicable laws,
                professionally, and in accordance with industry standards and ethics.
              </li>
              <li>
                The Seller agrees to fulfill the Agreement and deliver Products as specified in the Order.
              </li>
              <li>
                If the Seller cannot meet any conditions (deadline, quantity, quality, etc.), the Buyer will
                be informed in a timely manner, with reasons provided and solutions proposed.
              </li>
            </ol>
          </li>
          <li>
            Product Prices and Payment
            <ol>
              <li>
                The Seller reserves the right to change product prices without notice.
              </li>
              <li>
                Payment is made using methods offered by the online store, as described in the “Payment
                Methods” section.
              </li>
            </ol>
          </li>
          <li>
            Product Delivery
            <ol>
              <li>
                The online store accepts, processes, and fulfills all orders, while delivery is provided by
                authorized partners.
              </li>
              <li>
                The Buyer agrees to provide an accurate delivery address and to receive the Products
                personally. Delivery to the Buyer’s address does not grant the right to claim against the
                Seller if received by another person.
              </li>
              <li>
                The Buyer must check the shipment with the delivery representative and sign a document
                to confirm receipt in good condition.
              </li>
              <li>
                Delivery fees and details are provided in the “Delivery” section.
              </li>
              <li>
                If Products cannot be delivered in one shipment, the Seller may deliver in multiple
                shipments.
              </li>
              <li>
                The Seller may change delivery time after notifying the Buyer.
              </li>
              <li>
                Delivery fees depend on the chosen delivery method.
              </li>
            </ol>
          </li>
          <li>
            Product Quality Guarantee and Shelf Life
            <ol>
              <li>
                Product characteristics are listed in each product description. Manufacturers/importers
                are responsible for the correctness of the information, and the Seller is responsible only
                for correctly presenting it.
              </li>
              <li>
                The Seller is not responsible for discrepancies in appearance due to monitor settings.
              </li>
              <li>
                If no warranty is provided, applicable legal guarantees apply.
              </li>
            </ol>
          </li>

          <li>
            Product Returns and Exchanges
            <ol>
              <li>
              The Buyer can only exercise the right to return if the Product is undamaged and its
              appearance has not significantly changed.
              </li>
              <li>
              Products must be returned in the original packaging with documents. The Buyer must
              contact the Seller at info@noraspora.lv before returning.
              </li>
              <li>
              The Seller may refuse returns or refunds if the Product shows signs of use or damage.
              </li>
            </ol>
          </li>

          <li>
            Information Exchange
            <ol>
              <li>
              All notices from the Seller are sent to the Buyer’s registered email.
              </li>
              <li>
              The Buyer sends notices and questions via the contact details in the “Contacts” section.
              </li>
            </ol>
          </li>

          <li>
          Final Provisions
          <ol>
            <li>
            The company may update the Terms.
            </li>
            <li>
            All disputes arising from these Terms are resolved through negotiation. If an agreement
            cannot be reached, disputes are resolved under the laws of the Republic of Latvia.
            </li>
          </ol>
          </li>

          </ol>
      </div>
    )
  }

  // --- Default Latvian Version ---
  // If lang is not 'en' (or is null/undefined), display the original Latvian
  return (
    <div className="noteikumi">
      <Helmet>
        <title>Nora Spora - Lietošanas noteikumi</title>
        <meta name="description" content="Izpētiet mūsu lietošanas noteikumus.." />
        <meta name="keywords" content="privātuma politika, lietosanas noteikumi, datu aizsardzība, personas dati, NORA SPORA" />
        <meta name="robots" content="index, follow" />
      </Helmet>
        <h2 className="light">Lietošanas noteikumi</h2>
        <ol>
            <li>Vispārīgie noteikumi
                <ol>
                    <li>
                    Šie Noteikumi stājas spēkā, kad Pircējs tos ir apstiprinājis. Pircējs ir izveidojis iepirkumu grozu un pēdējā iepirkšanās procesa solī atzīmējis ķeksīti “Esmu izlasījis un piekrītu lapas noteikumiem” un nospiedis “Pasūtīt” pogu.
                    </li>
                    <li>
                    Pircējs apņemas pasūtīt un pieņemt Preces un samaksāt par tām Pasūtījuma cenu Līgumā noteiktā kārtībā. Preču piegāde tiek veikta tikai interneta veikalā www.noraspora.lv norādītajā teritorijā.
                    </li>
                    <li>
                    Pircējs nav tiesīgs iegādāties interneta veikalā www.noraspora.lv pieejamās Preces, ja nav iepazinies ar Pirkšanas noteikumiem vai nepiekrīt tiem.
                    </li>
                    <li>
                    Preču cenas interneta veikalā www.noraspora.lv ir norādītas eiro, atbilstoši spēkā esošajos normatīvajos aktos noteiktai kārtībai. Cenā nav iekļautas Preces piegādes izmaksas. Preču piegādes cena tiek norādīta atsevišķi, veicot katru Pasūtījumu.
                    </li>
                </ol>
            </li>
            <li>
                Personas datu aizsardzība
                <ol>
                    <li>
                    noraspora.lv rūpējas par savu Pircēju privātumu un personas datu aizsardzību, ievēro Pircēju tiesības uz personas datu apstrādes likumību saskaņā ar Eiropas Parlamenta un Padomes 2016. gada 27. aprīļa Regulu 2016/679 par fizisku personu aizsardzību attiecībā uz personas datu apstrādi un šādu datu brīvu apriti un citiem Latvijas Republikā spēkā esošajiem normatīvajiem aktiem, atbildīgo institūciju izdotajiem saistošajiem norādījumiem un noteikumiem privātuma un datu apstrādes jomā
                    </li>
                    <li>
                    Pārdevējs apņemas apstrādāt šajā līgumā minētos personas datus, saglabāt tos tikai atbilstoši paredzētajam mērķim un tam nepieciešamajā apjomā, tajā skaitā servisa uzlabošanai, reklāmas materiālu izsūtīšanai. Pārdevējs ir tiesīgs nodot Pircēja personas datus sadarbības partneriem un datu apstrādes kompānijām, kas strādā Pārdevēja labā. Apkopotā informācija var tikt izmantota stratēģiskiem un mārketinga mērķiem.
                    </li>
                </ol>
            </li>
            <li>
                Pirkšanas – pārdošanas līguma noslēgšana
                <ol>
                    <li>
                    Līgums starp noraspora.lv un Pircēju stājas spēkā brīdī, kad Pircējs Mājaslapā ir iepazinies ar izvēlētās preces aprakstu, izvēlējies Preces, noformējis Pirkuma grozu, tādējādi apliecinot, ka preces atbilst Pircēja izvirzītajām prasībām, ir piekritis Noteikumiem un Privātuma politikai, ir veicis Pasūtījuma apmaksu un ir saņēmis Pasūtījumu.
                    </li>
                    <li>
                    Interneta veikalam nav pienākums atsevišķi paziņot Pircējam par savu piekrišanu līguma slēgšanai. Tiek uzskatīts, ka interneta veikals apstiprina pasūtījumu no brīža, kad tas ir apmaksāts.
                    </li>
                    <li>
                    Katrs starp Pircēju un Pārdevēju noslēgtais līgums (pasūtījums) tiek reģistrēts un uzglabāts interneta veikala datu bāzē.
                    </li>
                </ol>
            </li>
            <li>
                Pircēja tiesības un pienākumi
                <ol>
                    <li>
                    Pircējam – fiziskai personai ir atteikuma tiesības. Pircējs var izmantot atteikuma tiesības attiecībā uz vietnē www.noraspora.lv nopirktām precēm 14 dienu laikā no brīža, kad tās nonākušas Pircēja valdījumā. Epasts ar informāciju par atgriežamo preci un pasūtījuma numuru jāraksta uz info@noraspora.lv.
                    </li>
                    <li>
                    Piekļūstot Mājaslapai vai lietojot to, Jums ir jāievēro šeit izklāstītie Noteikumi un nosacījumi, un Mājaslapā publicētie īpašie brīdinājumi vai norādījumi attiecībā uz piekļuvi vai lietošanu. Jums vienmēr jārīkojas labticīgi un saskaņā ar likumu.
                    </li>
                    <li>
                    Pircējs var izmantot atgriešanas tiesības tikai tad, ja prece nav bojāta vai tās izskats nav būtiski mainījies. Pircējs ir atbildīgs par to, lai Precei nesamazinātos tās vērtība, kvalitāte un drošums. Pretējā gadījumā Pārdevējam ir tiesības atteikt Pircējam atteikuma tiesību izmantošanu attiecībā uz piegādāto Preci.
                    </li>
                </ol>
            </li>
            <li>
                Pircēja pienākumi
                <ol>
                    <li>
                    Pircējs apņemas reģistrācijas formā sniegt tikai pareizu un pilnīgu informāciju. Mainoties reģistrācijas formā norādītajai informācijai, Pircējam ir pienākums nekavējoties to atjaunot.
                    </li>
                    <li>
                    Pircējs apņemas taisnīgi un pareizi izmantot interneta veikalu, nekaitēt tā darbam vai stabilai darbībai Ja Pircējs nepilda šo pienākumu, Pārdevējam ir tiesības bez iepriekšēja brīdinājuma ierobežot, apturēt (pārtraukt) Pircēja piekļuvi interneta veikalam, un Pārdevējs nav atbildīgs par jebkādiem ar to saistītiem Pircēja zaudējumiem.
                    </li>
                    <li>
                    Pircējam ir jāsamaksā par pasūtītajām Precēm un jāsaņem tās šajos Noteikumos noteiktajā kārtībā.
                    </li>
                    <li>
                    Neskatoties uz citos Noteikumu punktos paredzētajām saistībām, Pircējs apņemas 48 stundu laikā pēc Preču saņemšanas pārbaudīt Preces un pārliecināties, ka saņemtās Preces ir tās, kuras Pircējs pasūtījis.
                    </li>
                    <li>
                    Pircējs apņemas nenodot trešajām personām savus pieteikšanās datus. Ja Pircējs pazaudē pieslēgšanās datus, viņam par to nekavējoties jāinformē Pārdevējs pa sadaļā “Kontakti” norādītajiem kontaktiem. Pārdevējs nav atbildīgs par trešo personu rīcību, izmantojot Pircēja pieslēgšanās datus.
                    </li>
                    <li>
                    Ja Pircējs preču piegādes laikā bez svarīga iemesla atsakās pieņemt preces, Pircējam ir jāsedz preces piegādes un atgriešanas izmaksas, kas tiek ieturētas no Pircēja samaksātajiem naudas līdzekļiem par pasūtītajām precēm.
                    </li>
                </ol>
            </li>

            <li>
          Pārdevēja tiesības
          <ol>
            <li>
              Pārdevējam ir tiesības Pakalpojuma sniegšanā piesaistīt savu personālu vai izmantot apakšuzņēmējus.
            </li>
            <li>
              Pārdevējam ir tiesības bez iepriekšēja brīdinājuma ierobežot, apturēt (pārtraukt) Pircēja piekļuvi interneta veikalam, un Pārdevējs nav atbildīgs par jebkādiem ar to saistītiem Pircēja zaudējumiem.
            </li>
            <li>
              Pārdevējam ir tiesības anulēt pasūtījumu, iepriekš nebrīdinot Pircēju, ja Pircējs 3 (trīs) darba dienu laikā nesamaksā par preci ar veikala mājaslapā norādītajiem norēķinu veidiem.
            </li>
            <li>
              Ja rodas šaubas par pasūtījumā sniegto informāciju, Pārdevējs sazinās ar Pircēju pa pasūtījumā norādītajiem kontaktiem. Šajā gadījumā preču piegāde notiek tad, kad Pircējs ir precizējis informāciju.
            </li>
            <li>
              Neparedzētu apstākļu gadījumā Pārdevējs var uz laiku vai pavisam pārtraukt interneta veikala darbību, iepriekš nebrīdinot Pircēju. Šajā gadījumā Pārdevējs apņemas pildīt ar Pircēju noslēgto pirkuma-pārdošanas līgumu vai atdot Pircēja samaksātos naudas līdzekļus.
            </li>
          </ol>
        </li>
        <li>
          Pārdevēja pienākumi
          <ol>
            <li>
              Pārdevējs apņemas sniegt Pakalpojumu atbilstoši spēkā esošo normatīvo aktu prasībām, kvalitatīvi, ievērojot Pakalpojuma sniedzēja profesijai noteiktos standartus, kritērijus un ētikas normas.
            </li>
            <li>
              Pārdevējs apņemas izpildīt Līgumu un piegādāt Preces Pircējam saskaņā ar Līguma noteikumiem un tādā komplektācijā, kāda paredzēta Pasūtījumos.
            </li>
            <li>
              Ja Pārdevējs nevar izpildīt kādu no Noteikumos ietvertajiem izpildes nosacījumiem (termiņš, apjoms, kvalitāte u.c.), tas savlaicīgi informē Pircēju, sazinoties pa norādīto telefona numuru vai e-pastu, norādot iemeslus un piedāvājot izdarīt grozījumus Pasūtījuma vai Noteikumu nosacījumos. Risinājums tiek rasts atbilstoši situācijai, un abām pusēm vienojoties.
            </li>
          </ol>
        </li>
        <li>
          Preču cenas un apmaksas kārtība
          <ol>
            <li>
              Pārdevējs patur tiesības mainīt preču cenas bez iepriekšēja brīdinājuma.
            </li>
            <li>
              Pircējs norēķinās par precēm, izmantojot e-veikala piedāvātos apmaksas veidus, kas aprakstīti sadaļā “Maksājuma veidi”.
            </li>
          </ol>
        </li>
        <li>
          Preču piegāde
          <ol>
            <li>
              Mēs nodrošinām visu Internetveikalā pieejamo preču pasūtījumu pieņemšanu, apstrādi un izpildi, savukārt preču piegādes nodrošina mūsu pilnvaroti sadarbības partneri – preču piegādes pakalpojumu sniedzēji.
            </li>
            <li>
              Pasūtot preces, pircējs apņemas norādīt precīzu preču piegādes adresi.
            </li>
            <li>
              Pircējs apņemas preces saņemt pats. Gadījumā, ja Pircējs pats nevar pieņemt preces un preces tiek piegādātas uz Pircēja norādīto adresi, Pircējam nav tiesību izvirzīt Pārdevējam pretenzijas par preces piegādi nepareizai personai.
            </li>
            <li>
              Preču piegādes brīdī Pircējam kopā ar pilnvaroto pārstāvi jāpārbauda sūtījuma stāvoklis. Pircējam parakstot rēķinu (pavadzīmi) vai citu sūtījuma nodošanas-pieņemšanas dokumentu, tiek uzskatīts, ka sūtījums ir piegādāts atbilstošā stāvoklī.
            </li>
            <li>
              Piegādes maksa un sīkāka informācija saistībā ar preču piegādi ir sniegta interneta veikala sadaļā “Piegāde”.
            </li>
            <li>
              Ja pasūtītās preces nav iespējams piegādāt vienā sūtījumā, Pārdevējam ir tiesības preces piegādāt vairākos sūtījumos.
            </li>
            <li>
              Pārdevējam ir tiesības, iepriekš informējot Pircēju, mainīt Preču piegādes laiku.
            </li>
            <li>
              Par preču piegādi jāmaksā piegādes maksa. Piegādes maksa ir atkarīga no izvēlētā piegādes veida.
            </li>
          </ol>
        </li>
        <li>
          Produktu kvalitātes garantija un derīguma termiņš
          <ol>
            <li>
              Visu pārdodamo Preču īpašības ir norādītas katras Preces aprakstā. Preču ražotāji un (vai) importētāji ir atbildīgi par informāciju par Preču īpašībām (tās pareizību), un Pārdevējs ir atbildīgs tikai par šīs informācijas pareizu sniegšanu (pārsūtīšanu) patērētājiem, ja vien likumā nav noteikts citādi. Gadījumos, kad likumdošana nosaka noteiktu derīguma termiņu konkrētām Precēm, Pārdevējs apņemas pārdot šādas Preces Pircējam tādā veidā, kas sniedz viņam reālu iespēju izmantot šādas Preces līdz derīguma termiņa beigām.
            </li>
            <li>
              Pārdevējs nav atbildīgs par to, ka interneta veikalā esošās preces pēc savas krāsas, formas vai citiem parametriem var neatbilst faktiskajam preces izmēram, formai un krāsai Pircēja izmantotā monitora īpašību dēļ.
            </li>
            <li>
              Gadījumā, ja Pārdevējs atsevišķiem preču veidiem nesniedz kvalitātes garantiju, tiek piemērota attiecīgajos tiesību aktos paredzētā garantija.
            </li>
          </ol>
        </li>

        <li>
          Preču atgriešana un maiņa
          <ol>
            <li>
            Pircējs var izmantot atgriešanas tiesības tikai tad, ja prece nav bojāta vai tās izskats nav būtiski mainījies. Pircējs ir atbildīgs par to, lai Precei nesamazinātos tās vērtība, kvalitāte un drošums. Pretējā gadījumā Pārdevējam ir tiesības atteikt Pircējam atteikuma tiesību izmantošanu attiecībā uz piegādāto Preci.
            </li>
            <li>
            Preces ir jāatgriež oriģinālajā Preču un sūtījuma iepakojumā kopā ar Preču dokumentiem. Pirms preču atgriešanas Pircējam ir jāsazinās ar Pārdevēju, rakstot e-pastu uz info@noraspora.lv.
            </li>
            <li>
            Pārdevējam ir tiesības nepieņemt Preci un atteikt Pircējam izmantot atteikuma tiesības, kā arī neatmaksāt Pircēja par Preci samaksāto naudu, ja Preces atgriešanas brīdī ir konstatējis bojājumus Precei (noņemtas un / vai sabojātas etiķetes, noplēstas aizsardzības plēves u. c.) un / vai ir konstatētas Preces lietošanas pazīmes.
            </li>
          </ol>
        </li>

        <li>
          Informācijas apmaiņa
          <ol>
            <li>
            Pārdevējs visus paziņojumus nosūta uz Pircēja reģistrācijas anketā norādīto e-pasta adresi.
            </li>
            <li>
            Pircējs visus paziņojumus un jautājumus nosūta uz Pārdevēja interneta veikala sadaļā “Kontakti” norādītajiem kontaktiem.
            </li>
          </ol>
        </li>

        <li>
        Nobeiguma noteikumi
        <ol>
          <li>
          Uzņēmums var atjaunināt noteikumus.
          </li>
          <li>
          Visi strīdi, kas rodas no šo noteikumu piemērošanas, tiek risināti sarunu ceļā. Ja vienošanās netiek panākta, strīdi tiek risināti saskaņā ar Latvijas Republikas likumiem.
          </li>
        </ol>
        </li>

        </ol>
    </div>
  )
}

export default LietosanasNoteikumi